import { render, staticRenderFns } from "./CompetitionRegistrationInfo_phone.vue?vue&type=template&id=c836e244&scoped=true"
import script from "./CompetitionRegistrationInfo_phone.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistrationInfo_phone.vue?vue&type=script&lang=js"
import style1 from "./CompetitionRegistrationInfo_phone.vue?vue&type=style&index=1&id=c836e244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836e244",
  null
  
)

export default component.exports